import { render } from "./TeacherList.vue?vue&type=template&id=194926fc"
import script from "./TeacherList.vue?vue&type=script&lang=js"
export * from "./TeacherList.vue?vue&type=script&lang=js"

import exportComponent from "/root/.jenkins/workspace/外网-学校主页/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__